import { getUserHdWallets } from 'entities/payment/api';
import { actionTypes } from 'entities/payment/model/action-types';
import { actions } from 'entities/payment/model/reducer';
import { createAppAsyncThunk, logger } from 'shared';

export const getUserPaymentWallets = createAppAsyncThunk(
  actionTypes.GET_PAYMENT_WALLETS,
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await getUserHdWallets();

      dispatch(actions.updatePaymentState({ paymentHdWallets: data }));

      return null;
    } catch (error) {
      logger(actionTypes.GET_PAYMENT_WALLETS, error);

      return rejectWithValue(error);
    }
  },
);
